<template>
	<div class="goods">
		<v-head :title="title"></v-head>
		<div class="content">
		 <ul>
		 	<li>
		 	 <p><span>会议名称：</span><font>第二届全国水生植物资源与环境学术研讨会</font></p>
		 	 <p><span>会场名称：</span><font>永旺第一会议室</font></p>
		 	 <p><span>报名人：</span><font>高铭</font></p>
		 	 <p><span>论文名称：</span><font>天才在左疯子在右</font></p>
		 	 <p><span>审核状态：</span><font class="red">待审核</font></p>
		 	 <div class="download">
		 	 	<van-button type="info">论文下载</van-button>
		 	 </div>
		 	</li>
		 	<li>
		 	 <p><span>会议名称：</span><font>第二届全国水生植物资源与环境学术研讨会</font></p>
		 	 <p><span>会场名称：</span><font>永旺第一会议室</font></p>
		 	 <p><span>报名人：</span><font>高铭</font></p>
		 	 <p><span>论文名称：</span><font>天才在左疯子在右</font></p>
		 	 <p><span>审核状态：</span><font class="red">待审核</font></p>
		 	 <div class="download">
		 	 	<van-button type="info">论文下载</van-button>
		 	 </div>
		 	</li>
		 	<li>
		 	 <p><span>会议名称：</span><font>第二届全国水生植物资源与环境学术研讨会</font></p>
		 	 <p><span>会场名称：</span><font>永旺第一会议室</font></p>
		 	 <p><span>报名人：</span><font>高铭</font></p>
		 	 <p><span>论文名称：</span><font>天才在左疯子在右</font></p>
		 	 <p><span>审核状态：</span><font class="red">待审核</font></p>
		 	 <div class="download">
		 	 	<van-button type="info">论文下载</van-button>
		 	 </div>
		 	</li>		 	
		 </ul>

		</div>
	</div>
</template>
<script>
import vHead from "../../components/Subhead.vue";
import { Uploader,Toast,Button,ImagePreview } from "vant";

export default {
  data() {
    return {
     title:"会议论文",
     fileList: [],
     photoList:[],
    };
  },
  components: {
    vHead,
    [Uploader.name]: Uploader,
    [Toast.name]: Toast,
    [Button.name]: Button,
    [ImagePreview.name]: ImagePreview,
  },
  methods: {

  }
};
</script>

<style  lang="less" scoped>
.imgBox{ 
	padding:20px; 
    img{ width: 100%; }
}	
/deep/.van-nav-bar .van-icon{
  color: #fff;
}
.content{ padding:0 15px;}
.content li{ padding:15px 0; border-bottom: #dfdfdf solid 1px; }
.content li p{ line-height:25px; overflow: hidden;}
.content li p span{ display: block; float: left; width:20%; text-align: right; }
.content li p font{ display: block; float: left; width:80%; }
.download{ text-align: right;
	.van-button{ height: 40px; line-height: 30px; }
}
.red{ color: #e12121; }
</style>